import React from 'react';
import { useSelector } from 'react-redux';
import { useQuery, useMutation } from 'react-fetching-library';
import { Box, Button, Menu, MenuItem, ListItem, ListItemIcon, ListItemText, ListItemButton, ListItemSecondaryAction, Divider, IconButton, Portal, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { BarChart } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Iconify from '../../../components/Iconify';
import { getSpreadsheetTemplates,
  downloadSpreadsheet,
  deleteSpreadsheetTemplateAction,
  getTransportReport,
  getPromotionsReport,
  getSeatAvailabilityReport,
  getSeatAvailabilityResortReport,
  getMainReportZS,
  getMainReportZSManager,
  eventGroupExcelReport,
  getSaleExecutionReport,
  getQualificationCardList,
  getComprehensiveSalesPlanReport } from '../../../services/request';
import CreateSpreadsheetTemplateModal from './CreateSpreadsheetTemplateModal';
import CreateSummaryModal from './CreateSummaryReport';
import EditSpreadsheetTemplateModal from './EditSpreadsheetTemplateModal';
import GenerateSalesReportModal from './GenerateSalesReportModal';
import TransportReportDraggable from './TransportReportDraggable';
import TransportSumReportModal from './TransportSumReport';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import EditIcon from '@mui/icons-material/Edit';
import toast from 'react-hot-toast';

export default function WRGenerateSpreadsheet({ idList }) {
  const { mutate } = useMutation(downloadSpreadsheet);
  const { loading, payload, error } = useQuery(getSpreadsheetTemplates());
  const { mutate: deleteMutate } = useMutation(deleteSpreadsheetTemplateAction);
  const { mutate: promotionsMutate, loading: promotionLoading } = useMutation(getPromotionsReport);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openAddTemplateModal, setOpenAddTemplateModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [templates, setTemplates] = React.useState([]);
  const [templateId, setTemplateId] = React.useState(0);

  const handleOpenAddTemplateModal = () => {
    setOpenAddTemplateModal(true);
    handleClose();
  };

  const handleCloseModal = () => setOpenAddTemplateModal(false);

  const handleOpenEditModal = id => {
    setOpenEditModal(true);
    setTemplateId(id);
    handleClose();
  };

  const handleCloseEditModal = () => setOpenEditModal(false);

  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = async (id, name) => {
    const { error: mutateError, payload: mutatePayload } = await mutate(id, { 'id_list': idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `${name}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadPromotionsReport = async () => {
    const { error: mutateError, payload: mutatePayload } = await promotionsMutate({ 'id_list': idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Promocje.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDelete = async id => {
    const { error: mutateError, payload: mutatePayload } = await deleteMutate(id);
    if (!mutateError) {
      setTemplates(prev => prev.filter(template => template.id !== id));
      toast.success('Szablon został usunięty');
    } else {
      toast.error('Nie udało się usunąć');
    }
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setTemplates(payload.results);
    }
  }, [loading]);

  return (
    <>
      <Box sx={{ p: 3, width: '100%', display: 'flex', flexDirection: 'row' }}>
        <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          fullWidth
          endIcon={<Iconify icon={'ri:file-excel-2-fill'}/>}
          onClick={handleClick}
        >
          Wygeneruj raport
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button'
          }}
          style={{ maxHeight: '60vh' }}
        >
          <MenuItem onClick={handleDownloadPromotionsReport} disabled={promotionLoading}>
            <ListItemIcon>
              {promotionLoading ? <CircularProgress size={20}/> : <FileDownloadIcon />}
            </ListItemIcon>
            <ListItemText>
              Rabaty
            </ListItemText>
          </MenuItem>
          <MenuItem onClick={handleOpenAddTemplateModal}>
            <ListItemIcon>
              <AddIcon />
            </ListItemIcon>
            <ListItemText>
              Nowy szablon
            </ListItemText>
          </MenuItem>
          <Divider>Szablony</Divider>
          {templates.map(template => (
            <ListItem
              key={template.id}
              sx={{ pr: '96px' }}
              disablePadding
            >
              <ListItemButton role={undefined} onClick={() => handleDownload(template.id, template.template_name)}>
                <ListItemIcon>
                  <FileDownloadIcon />
                </ListItemIcon>
                <ListItemText>
                  {template.template_name}
                </ListItemText>
              </ListItemButton>
              <ListItemSecondaryAction sx={{ width: '96px', display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                <IconButton edge="end" aria-label="comments" onClick={() => handleOpenEditModal(template.id)}>
                  <EditIcon color="primary"/>
                </IconButton>
                <IconButton edge="end" aria-label="comments" onClick={() => handleDelete(template.id)}>
                  <DeleteIcon color="error"/>
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}

        </Menu>
      </Box>
      {openAddTemplateModal ? <CreateSpreadsheetTemplateModal open={openAddTemplateModal} handleClose={handleCloseModal} setTemplates={setTemplates}/> : null}
      {openEditModal ? <EditSpreadsheetTemplateModal open={openEditModal} handleClose={handleCloseEditModal} templateId={templateId}/> : null}
    </>
  );
}
